

const updateViewHeight = () => {
  const vh = window.innerHeight
  document.documentElement.style.setProperty('--vh', `${vh}px`)
};


let appliedResizeListener = null
export const applyDynamicViewHeight = () => {
  if (!!appliedResizeListener) {
    window.removeEventListener('resize', appliedResizeListener)
  }
  appliedResizeListener = window.addEventListener('resize', () => requestAnimationFrame(updateViewHeight))
}